// pt-BR de efeitos externos sem resultado (decisão D41-B2, PRD AC08); completo para toda chave de en-operations.ts
// (checado pelo tipo). Linguagem simples: quem decide pode não ser da área técnica.
import type { enOperations } from "./en-operations.ts";

export const ptBROperations: Record<keyof typeof enOperations, string> = {
  "operations.title": "Efeitos externos sem resultado",
  "operations.intro": "Estas ações chegaram a um sistema externo, mas nenhum resultado foi registrado. Elas nunca são repetidas sozinhas.",
  "operations.introAdmin": "Confira o sistema externo e registre o que aconteceu: aconteceu (com a referência, se você tiver) ou não aconteceu.",
  "operations.readOnlyNotice": "Um administrador da organização precisa decidir. Você pode ver o que está pendente, mas só um administrador pode registrar o resultado.",
  "operations.loadFailed": "Não foi possível carregar os efeitos externos sem resultado",
  "operations.emptyTitle": "Nada pendente de decisão",
  "operations.emptyBody": "Nenhum efeito externo deste projeto está com resultado desconhecido.",
  "operations.col.operation": "Operação",
  "operations.col.destination": "Destino",
  "operations.col.requested": "Solicitado em",
  "operations.col.decision": "Decisão",
  "operations.noDestination": "Não registrado",
  "operations.happened": "Aconteceu",
  "operations.didNotHappen": "Não aconteceu",
  "operations.happenedFor": "Aconteceu: {operation}",
  "operations.didNotHappenFor": "Não aconteceu: {operation}",
  "operations.dialog.happenedTitle": "Registrar que aconteceu",
  "operations.dialog.didNotHappenTitle": "Registrar que não aconteceu",
  "operations.dialog.happenedBody": "Confirme somente depois de conferir o sistema externo e encontrar o efeito lá. A operação é encerrada e não será executada de novo.",
  "operations.dialog.didNotHappenBody": "Confirme somente depois de conferir o sistema externo e não encontrar nenhum vestígio do efeito. Ele será executado uma vez na próxima execução.",
  "operations.note": "O que você conferiu",
  "operations.noteHint": "Onde você olhou, por exemplo a branch, a lista de pull requests ou a página do deploy. Fica guardado com a decisão.",
  "operations.providerRef": "Referência no provedor",
  "operations.providerRefHint": "Número do pull request, SHA do commit ou id do deploy, se você souber.",
  "operations.confirmHappened": "Confirmar: aconteceu",
  "operations.confirmDidNotHappen": "Confirmar: não aconteceu",
  "operations.resolvedDone": "Registrado como concluído: {operation}.",
  "operations.resolvedNotDone": "Registrado como não concluído: {operation}. Será executado uma vez na próxima execução.",
  "operations.kind.gitCommit": "Criar commit",
  "operations.kind.gitPush": "Enviar commits (push)",
  "operations.kind.gitPushPublish": "Publicar código (push)",
  "operations.kind.gitIntegrate": "Integrar branch",
  "operations.kind.prCreate": "Abrir pull request",
  "operations.kind.githubRepositoryCreate": "Criar repositório no GitHub",
  "operations.kind.githubDeployKeyAdd": "Adicionar chave de deploy no GitHub",
  "operations.kind.coolifyAppCreate": "Criar aplicação no Coolify",
  "operations.kind.coolifyKeyCreate": "Criar chave no Coolify",
  "operations.kind.coolifyDeploy": "Fazer deploy no Coolify",
};
